module.exports = __webpack_public_path__ + "img/dk.d046fb5b.svg";